import clsx from "clsx"

import { objectColorByStatus, userColorByStatus } from "@constants/colorByStatus"

import styles from "./AvatarStatus.module.scss"
import { AvatarStatusProps } from "./AvatarStatus.types"

const colorByStatus = {
    ...userColorByStatus,
    ...objectColorByStatus,
}

export default function AvatarStatus(props: AvatarStatusProps) {
    const { variant, status } = props

    return (
        <div
            className={clsx(styles.base, styles[variant])}
            style={
                {
                    "--status-color": colorByStatus[status],
                } as React.CSSProperties
            }
        />
    )
}
